export default __webpack_public_path__ + "static/media/Collage-small.155015c1.jpeg";